import { errorUtil } from '../util/error-util'
import { HttpResponse, coreDaoFactory } from '@grndhouse/react-common'

// TODO common-web: move to common-web or we should move it closer to node-core (or new common project between core FE and BE so
// that it's data can be used for testing i both ends
const dao = coreDaoFactory({
  onError: async (error: Error) => {
    errorUtil.handleHttpError(error)
  },
})
export const coreDao = {
  ...dao,
  getLegalTermsAndConditions: async (): Promise<string> => {
    const url = '/legal/terms-and-conditions'
    const result = await dao._http.get<HttpResponse<string>>(url)
    return result.data.data[0]
  },
  getLegalPrivacyPolicy: async (): Promise<string> => {
    const url = '/legal/privacy-policy'
    const result = await dao._http.get<HttpResponse<string>>(url)
    return result.data.data[0]
  },
  updateHustler: async (params: { profile: { username: string } }): Promise<void> => {
    const { profile } = params
    const url = '/hustlers/me'
    const result = await dao._http.patch<HttpResponse<void>>(url, { profile })
    return result.data.data[0]
  },
}
